import { ResultFileType } from '@consigli/types';

import Drawing from '@/assets/images/layout/2d_img.png';
import Specifications from '@/assets/images/layout/doc_img.png';
import IfcFiles from '@/assets/images/layout/ifc_img.png';
import Reports from '@/assets/images/layout/reports_img.png';
import { ResultDocumentOrder } from '@/util/document-ordering';

import { SectionConfig } from './types';

// Configuration for INPUT files (simple categorization)
export const INPUT_SECTIONS: SectionConfig[] = [
  {
    key: 'ifc',
    translationKey: 'optimization-tabs.ifc-files',
    descriptionKey: 'optimization-tabs.ifc-files-description',
    image: IfcFiles,
    groupingFn: (document) => document.extension === '.ifc',
  },
  {
    key: 'specifications',
    translationKey: 'optimization-tabs.specifications',
    descriptionKey: 'optimization-tabs.specifications-description',
    image: Specifications,
    groupingFn: (document) => document.extension !== '.ifc',
  },
];

// Configuration for SITE DUE DILIGENCE uploaded documents
export const SITE_DUE_DILIGENCE_SECTIONS: SectionConfig[] = [
  {
    key: 'uploaded-files',
    translationKey: 'package-creation.uploaded-files-section',
    descriptionKey: 'package-creation.uploaded-files-description',
    image: Specifications,
    groupingFn: () => true, // All documents in one section
  },
];

// Configuration for LUMINAIRE SCHEDULE input documents
export const LUMINAIRE_INPUT_SECTIONS: SectionConfig[] = [
  {
    key: 'luminaire',
    translationKey: 'optimization-tabs.luminaire-files',
    descriptionKey: 'optimization-tabs.luminaire-ref-description',
    image: Reports,
    groupingFn: () => true,
  },
];

// Configuration for RESULT files (complex categorization by file type)
export const RESULT_SECTIONS: SectionConfig[] = [
  {
    key: 'ifc',
    fileType: ResultFileType.IFC,
    orderPriority: ResultDocumentOrder.IFC,
    translationKey: 'optimization-tabs.ifc-files',
    descriptionKey: 'optimization-tabs.ifc-files-result-description',
    image: IfcFiles,
  },
  {
    key: 'revit',
    fileType: ResultFileType.REVIT,
    orderPriority: ResultDocumentOrder.REVIT,
    translationKey: 'optimization-tabs.revit-files',
    descriptionKey: 'optimization-tabs.revit-files-description',
    image: Specifications,
  },
  {
    key: 'drawing',
    fileType: ResultFileType.DRAWINGS_2D,
    orderPriority: ResultDocumentOrder.DRAWINGS_2D,
    translationKey: 'optimization-tabs.2d-drawing',
    descriptionKey: 'optimization-tabs.2d-drawing-description',
    image: Drawing,
    interpolation: { serviceType: 'package-creation.new' },
  },
  {
    key: 'report',
    fileType: ResultFileType.REPORTS,
    orderPriority: ResultDocumentOrder.REPORTS,
    translationKey: 'optimization-tabs.reports',
    descriptionKey: 'optimization-tabs.reports-description',
    image: Reports,
  },
  {
    key: 'acousticReports',
    fileType: ResultFileType.ACOUSTIC_REPORT,
    orderPriority: ResultDocumentOrder.ACOUSTIC_REPORT,
    translationKey: 'optimization-tabs.acoustic-reports',
    descriptionKey: 'optimization-tabs.acoustic-reports-description',
    image: Reports,
  },
  {
    key: 'fireReports',
    fileType: ResultFileType.FIRE_REPORT,
    orderPriority: ResultDocumentOrder.FIRE_REPORT,
    translationKey: 'optimization-tabs.fire-reports',
    descriptionKey: 'optimization-tabs.fire-reports-description',
    image: Reports,
  },
  {
    key: 'commissioningReports',
    fileType: ResultFileType.COMMISSIONING_REPORT,
    orderPriority: ResultDocumentOrder.COMMISSIONING_REPORT,
    translationKey: 'optimization-tabs.commissioning-reports',
    descriptionKey: 'optimization-tabs.commissioning-reports-description',
    image: Reports,
  },
  {
    key: 'ventilationRates',
    fileType: ResultFileType.VENTILATION_RATES,
    orderPriority: ResultDocumentOrder.VENTILATION_RATES,
    translationKey: 'optimization-tabs.ventilation-rates',
    descriptionKey: 'optimization-tabs.ventilation-rates-description',
    image: Reports,
  },
  {
    key: 'strategies',
    fileType: ResultFileType.STRATEGIES,
    orderPriority: ResultDocumentOrder.STRATEGIES,
    translationKey: 'optimization-tabs.strategies',
    descriptionKey: 'optimization-tabs.strategies-description',
    image: Reports,
  },
  {
    key: 'others',
    fileType: ResultFileType.OTHERS,
    orderPriority: ResultDocumentOrder.OTHERS,
    translationKey: 'optimization-tabs.others',
    descriptionKey: 'optimization-tabs.others-description',
    image: Drawing,
  },
  {
    key: 'luminaire',
    fileType: ResultFileType.LUMINAIRE,
    orderPriority: ResultDocumentOrder.LUMINAIRE,
    translationKey: 'optimization-tabs.luminaire-files',
    descriptionKey: 'optimization-tabs.luminaire-res-description',
    image: Reports,
  },
];
